import React, { Component } from "react";
import 'antd/dist/antd.css';
import { Spinner } from 'reactstrap';
import axios from '../../../utils/request';
import { Select, Button, message } from 'antd';
import '../cccltd.css'
const { Option } = Select;

//Hr邀请原单位第一次决策
export class CCCCLTDOrgDecide extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tenantId: "",
            isReady: false,
            isLoading: true,
            errorMessage: "",
            orgDecideInfo: {
                applyId: "",
                isShowInfo: false,
                infoMsg: "",
                applicantName: "",
                email: "",
                jobName: "",
                orgList: []
            },
            oldOrgId: "",
            btnDisabled: false,
            btnSuccess: false,
            btnSuccessMsg: ""

        }
    };
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const commonParamater = urlParams.get("commonParamater");
        const tenantId = urlParams.get("tenantId");
        this.loadPage(tenantId, commonParamater);


        this.setState({ tenantId });
        this.loadPage(tenantId, commonParamater);
    };
    loadPage = (tenantId, commonParamater) => {
        const params = {
            tenantId,
            commonParamater
        }
        axios
            .get("/api/CCCCLTD/GetOrgDecideInfo", { params: params })
            .then(res => {
                const reqCode = res.data.code;
                const orgDecideInfo = res.data.data;
                let errorMessage = "";
                if (reqCode != "200") {
                    errorMessage = "错误信息：" + res.data.message;
                }

                this.setState({ isLoading: false, isReady: true, errorMessage, orgDecideInfo });

            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" + reason.response.data.message });
            })
            .finally(
            );
    };

    select_onchange = (value) => {
        this.setState({ oldOrgId: value });
    };

    start_invite = () => {
        console.log(this.state.oldOrgId);
        this.setState({ btnDisabled: true });
        if (this.state.oldOrgId === "") {
            message.error('原单位不能为空，请选择原单位！');
            this.setState({ btnDisabled: false });
        } else {
            const params = {
                tenantId: this.state.tenantId,
                applyId: this.state.orgDecideInfo.applyId,
                oldOrgId: this.state.oldOrgId
            }
            axios
                .get("/api/CCCCLTD/InviteOldOrgDecide", { params: params })
                .then(res => {
                    const reqCode = res.data.code;
                    const inviteOrgDecideInfo = res.data.data;
                    let errorMessage = "";
                    if (reqCode != "200") {
                        errorMessage = "错误信息：" + res.data.message;
                        this.setState({ btnDisabled: false, errorMessage });
                    } else {
                        if (inviteOrgDecideInfo["isSuccess"]) {
                            this.setState({ btnDisabled: false, btnSuccess: true, btnSuccessMsg: inviteOrgDecideInfo["infoMsg"] });
                        } else {
                            message.error(inviteOrgDecideInfo["infoMsg"]);
                            this.setState({ btnDisabled: false });
                        }
                    }
                })
                .catch(reason => {
                    this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" + reason.response.data.message, btnDisabled: false });
                })
                .finally(
                );
        }

    };
    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (<div style={{ textAlign: "center", marginTop: "65px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            } else {
                if (!this.state.orgDecideInfo.isShowInfo) {
                    return (<div style={{ textAlign: "center", marginTop: "65px" }}><span style={{ color: "red" }}>{this.state.orgDecideInfo.infoMsg}</span></div>)
                } else {
                    if (!this.state.btnSuccess) {
                        const options = this.state.orgDecideInfo.orgList.map(d => <Option key={d.orgId}>{d.orgName}</Option>);
                        return (
                            <div style={{ textAlign: "center", marginTop: "65px" }}>
                                <table style={{ width: "100%" }}>
                                    <tbody>
                                        <tr style={{ lineHeight: "45px" }}>
                                            <td style={{ width: "40%", textAlign: "right" }}><span>姓名：</span></td>
                                            <td style={{ width: "60%", textAlign: "left" }}> {this.state.orgDecideInfo.applicantName}</td>
                                        </tr>
                                        <tr style={{ lineHeight: "45px" }}>
                                            <td style={{ width: "40%", textAlign: "right" }}>邮箱：</td>
                                            <td style={{ width: "60%", textAlign: "left" }}> {this.state.orgDecideInfo.email}</td>
                                        </tr>
                                        <tr style={{ lineHeight: "45px" }}>
                                            <td style={{ width: "40%",textAlign: "right" }}>应聘职位：</td>
                                            <td style={{ width: "60%", textAlign: "left" }}> {this.state.orgDecideInfo.jobName}</td>
                                        </tr>
                                        <tr style={{ lineHeight: "45px" }}>
                                            <td style={{ width: "40%", textAlign: "right" }}>原单位<span style={{ "color": "red" }}>*</span>：</td>
                                            <td style={{ width: "60%", textAlign: "left" }}>
                                                <Select
                                                    onChange={this.select_onchange}
                                                    name="orgId"
                                                    showSearch
                                                    style={{ width: 250 }}
                                                    placeholder="请选择一个原单位"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {options}
                                                </Select>
                                            </td>
                                        </tr>
                                        <tr style={{ lineHeight: "40px" }}>
                                            <td></td>
                                            <td style={{ width: "60%", textAlign: "left" }}><Button type="primary" htmlType="button" onClick={this.start_invite} disabled={this.state.btnDisabled} >邀请原单位决策</Button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        )
                    } else {
                        return (<div style={{ textAlign: "center", marginTop: "65px" }}><span style={{ color: "green" }}>{this.state.btnSuccessMsg}</span></div>)
                    }
                }
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", padding: "15px" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }

    }
}